
import scrollIt from '../utils/scrollIt';

export default class scrollDown {
    
    static get selector() {
        return '.scrollDown';
    }

    constructor(el) {
        this.el = el;
        this.scrollTarget = document.querySelector(this.el.getAttribute('href'));
        this.setEvents();
    }

    setEvents() {
        this.el.addEventListener('click', this.e_click.bind(this));
    }
    
    e_click(e) {
        e.target.blur();
        e.preventDefault();
        scrollIt(this.scrollTarget.offsetTop, 800, 'easeInOutCubic');
    }

}